module.exports = __webpack_public_path__ + "img/add-user.4b8fa252.svg";